jQuery(document).ready(function($) {
	$('.wpcf7-validates-as-required').parent().prev().addClass('required');
});